<span class="title-text" #titleText>
  <ng-content></ng-content>
</span>
<ng-content select="cs-header-title-action"></ng-content>